<bci-wk-modal class="modal">
  <div class="container-modal">
    <img class="war" src="./assets/images/warning-sucursal.png" alt="waricon" />
    <div class="title wk-padding-top-24">
      <bci-wk-modal-title bciWkTypeH600
        >Selecciona otra comuna</bci-wk-modal-title
      >
    </div>
    <div class="subtitle">
      <p>
        El motivo que seleccionaste no está disponible en la comuna que
        elegiste.
      </p>
    </div>
    <bci-wk-modal-actions>
      <button bciWkButtonPrimary (click)="close()">
        Seleccionar otra comuna
      </button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
